import React from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import { Trash2, RotateCw, RotateCcw } from "react-feather";

import { rotateImageSrc } from "../../../../utils/helper";

const Gallery = ({ images, setImages, disabled }) => {
  const deleteImage = (imageId) => {
    setImages((prevState) => {
      return prevState.filter((image) => image.imageId !== imageId);
    });
  };

  const rotateImage = async (imageId, direction) => {
    const image = images.find((image) => image.imageId === imageId);

    let rotation = 0;
    if (direction === "clockwise") {
      rotation = 90;
    } else {
      rotation = -90;
    }

    try {
      const rotatedImageSrc = await rotateImageSrc(image.imageSrc, rotation);

      setImages((prevState) =>
        prevState.map((image) =>
          image.imageId === imageId
            ? { ...image, imageSrc: rotatedImageSrc }
            : image
        )
      );
    } catch (error) {
      console.error("Error rotating image:", error);
    }
  };

  return (
    <div className="mt-3 pt-2 border-top">
      <h4>Gallery</h4>
      <Row>
        {images.map((image, index) => {
          return (
            <Col key={index} xs={3} className="mb-3">
              <div className="position-relative">
                <Image src={`${image.imageSrc}`} fluid />
                <Button
                  variant="danger"
                  className="position-absolute top-0 start-0"
                  onClick={() => deleteImage(image.imageId)}
                  disabled={disabled}
                >
                  <Trash2 size={16} />
                </Button>
                <Button
                  variant="primary"
                  className="position-absolute bottom-0 start-0"
                  onClick={() =>
                    rotateImage(image.imageId, "counter-clockwise")
                  }
                  disabled={disabled}
                >
                  <RotateCcw size={16} />
                </Button>
                <Button
                  variant="primary"
                  className="position-absolute bottom-0 end-0"
                  onClick={() => rotateImage(image.imageId, "clockwise")}
                  disabled={disabled}
                >
                  <RotateCw size={16} />
                </Button>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default Gallery;
